import React, {useState , useEffect} from "react";
import {
  Box,
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,styled, TooltipProps, tooltipClasses,
  Button
} from "@mui/material";
import { useSalesContext } from "../../../Pages/SalesContext";
import "../css/stockistData.css";
import checkIcon from "../../../assets/images/check.svg";
import slashCircle from "../../../assets/images/slash-circle-01.svg";
interface CardData {
  tablets?: string[];
  sale: string[];
  nonSaleableReturn: string[];
  saleableReturn: string[];
}

const maxTextLength = 10;

const truncateText = (text: string, maxLength: number) => {
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};
const StockistDataComp: React.FC = React.memo(() => {
  const { kpiData, salesUnit, loading } = useSalesContext();

  const kpidata = kpiData.kpi_data;
   console.log("kpiData for stockist", kpidata, salesUnit);
const defaultCardData: { [key: string]: CardData } = {
  card1tabletName: {
    sale: [kpidata?.Card1_TotalStockist?.Net_Sale?.toString() || "0"],
    nonSaleableReturn: [
      kpidata?.Card1_TotalStockist?.NonSaleableReturnPer != null
        ? kpidata.Card1_TotalStockist.NonSaleableReturnPer.toFixed(2) + "%"
        : ""
    ],
    saleableReturn: [
      kpidata?.Card1_TotalStockist?.SaleableReturnPer != null
        ? kpidata.Card1_TotalStockist.SaleableReturnPer.toFixed(2) + "%"
        : ""
    ],
  },

  card2tabletName: {
    tablets: kpidata?.Card2_TopStockist?.map((s: any) => s.StockistName) || ["N/A"],
    sale: kpidata?.Card2_TopStockist?.map((s: any) => s.Net_Sale?.toString() || "N/A") || ["N/A"],
    nonSaleableReturn:
      kpidata?.Card2_TopStockist?.map((s: any) =>
        s.NonSaleableReturnPer != null ? s.NonSaleableReturnPer.toFixed(2) + "%" : "N/A"
      ) || ["N/A"],
    saleableReturn:
      kpidata?.Card2_TopStockist?.map((s: any) =>
        s.SaleableReturnPer != null ? s.SaleableReturnPer.toFixed(2) + "%" : "N/A"
      ) || ["N/A"],
  },

  card3tabletName: {
    tablets: kpidata?.Card3_BottmStockist?.map((s: any) => s.StockistName) || ["0"],
    sale: kpidata?.Card3_BottmStockist?.map((s: any) => s.Net_Sale?.toString() || "0") || ["0"],
    nonSaleableReturn:
      kpidata?.Card3_BottmStockist?.map((s: any) =>
        s.NonSaleableReturnPer != null ? s.NonSaleableReturnPer.toFixed(2) + "%" : "0"
      ) || [" "],
    saleableReturn:
      kpidata?.Card3_BottmStockist?.map((s: any) =>
        s.SaleableReturnPer != null ? s.SaleableReturnPer.toFixed(2) + "%" : "0"
      ) || [" "],
  },
};

  const [filteredData, setFilteredData] = useState<{ [key: string]: CardData }>(defaultCardData);
  console.log("filteredData", filteredData);
    useEffect(() => {
      if (kpiData) {
        setFilteredData(defaultCardData);
      }
    }, [kpiData]);
  const cardConfig = [
    {
      key: "card1tabletName",
      title: `Total `,
      color: "#E2F6FF",
      data: filteredData.card1tabletName,
    },
    {
      key: "card2tabletName",
      title: `Top 3 Stockists (Sales) `,
      color: "#F2F6E5",
      data: filteredData.card2tabletName,
    },
    {
      key: "card3tabletName",
      title: `Bottom 3 Stockists (Sales) `,
      color: "#FDECEF",
      data: filteredData.card3tabletName,
    },
  ];

const formatSaleValue = (number: string | number | undefined): string => {
  if (number === null || isNaN(Number(number)) || !isFinite(Number(number))) return "";

  const unit = salesUnit || "Lacs";
  number = Number(number);

  if (unit === "Crores") {
    return (number / 10000000).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } else if (unit === "Lacs") {
    return (number / 100000).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } else {
    return number.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
};


  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      border: '1px solid #dadde9',
    },
  }));
  function handleKeep(item: string, cardKey: keyof typeof defaultCardData) {
    setFilteredData((prev) => {
      const index = defaultCardData[cardKey].tablets?.indexOf(item) ?? -1;
      if (index === -1) return prev;
  
      return {
        ...prev,
        [cardKey]: {
          tablets: [item],
          sale: [defaultCardData[cardKey].sale[index]],
          nonSaleableReturn: [defaultCardData[cardKey].nonSaleableReturn[index]],
          saleableReturn: [defaultCardData[cardKey].saleableReturn[index]],
        },
      };
    });
  }
  
  function handleExclude(item: string, cardKey: keyof typeof defaultCardData) {
    setFilteredData((prev) => {
      const idxToRemove = defaultCardData[cardKey].tablets?.indexOf(item) ?? -1;
      if (idxToRemove === -1) return prev;
  
      return {
        ...prev,
        [cardKey]: {
          tablets: defaultCardData[cardKey].tablets?.filter((_, i) => i !== idxToRemove) || [],
          sale: defaultCardData[cardKey].sale?.filter((_, i) => i !== idxToRemove) || [],
          nonSaleableReturn: defaultCardData[cardKey].nonSaleableReturn?.filter((_, i) => i !== idxToRemove) || [],
          saleableReturn: defaultCardData[cardKey].saleableReturn?.filter((_, i) => i !== idxToRemove) || [],
        },
      };
    });
  }
    const getYesterdayDate = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

 
    const options: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short", year: "2-digit" as "2-digit" };
    return yesterday.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  return (
    <Box className="stockist-container" sx={{ p: 2 }}>
       <Box className="header">
                    <Box className="title-container">
                      <Typography className="Filter-title" sx={{ fontSize: "14px" }}>
                        Data Till Date {getYesterdayDate()} ({salesUnit || "Lacs"})
                      </Typography>
                    </Box>
                  </Box>
      <Stack direction={{ xs: "column", sm: "row" }}>
        {cardConfig.map((sale, index) => (
          <Card
            className="stockist-item"
            key={index}
            sx={{
              backgroundColor: sale.color,
              borderRadius: "16px",
              boxShadow: "none",
            
            }}
          >
            <Box className="stockist-title-container">
              <Typography className="stockist-title-text-2" fontWeight="bold">
                {sale.title}
              </Typography>
            </Box>
            <Box>
              {index === 0 ? (
                <Table className="stockist-table-container" stickyHeader size="small">
                  <TableHead className="tablet-stockist-table-head">
                    <TableRow className="tablet-stockist-table-row">
                      <TableCell className="data-text" style={{textAlign :'center'}}>Sale</TableCell>
                      <TableCell className="data-text">   %Expiry</TableCell>
                      <TableCell className="data-text"> %Return</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow >
                   
                      <Tooltip title={`Sale: ${formatSaleValue(sale.data.sale[0])}`} arrow>
                        <TableCell className="data-text">{formatSaleValue(sale.data.sale[0])}</TableCell>
                      </Tooltip>
                   <Tooltip
  title={`Non-Saleable Return: ${sale.data.nonSaleableReturn[0] !== null ? sale.data.nonSaleableReturn[0] : ""}`}
  arrow
>
  <TableCell className="data-text">
    {sale.data.nonSaleableReturn[0] !== null ? sale.data.nonSaleableReturn[0] : ""}
  </TableCell>
</Tooltip>

<Tooltip
  title={`Saleable Return: ${sale.data.saleableReturn[0] !== null ? sale.data.saleableReturn[0] : ""}`}
  arrow
>
  <TableCell className="data-text">
    {sale.data.saleableReturn[0] !== null ? sale.data.saleableReturn[0] : ""}
  </TableCell>
</Tooltip>

                    </TableRow>
                  </TableBody>
                </Table>
              ) : (
                <Table className="stockist-table-container" stickyHeader size="small">
                  <TableHead className="tablet-stockist-table-head">
                    <TableRow >
                      <TableCell className="data-text">Stockist Name</TableCell>
                      <TableCell  className="sale-data-text">Sale</TableCell>
                      <TableCell className="data-text"> %Expiry </TableCell>
                      <TableCell className="data-text">% Return </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sale.data.tablets?.map((tablet, idx) => (
                      <TableRow key={idx} className="tablet-stockist-table-row">
                         <HtmlTooltip
                    title={
                      <div className="custom-tooltip">
                        <div className="tablet-info-box">
                          <div className="tablet-breakwise-button-2"> {tablet}</div>
                        </div>
                      </div>
                    }
                    arrow
                  >
                 <Tooltip title={tablet} arrow>
  <TableCell className="data-text">
    {truncateText(tablet, maxTextLength)}
  </TableCell>
</Tooltip>

                  </HtmlTooltip>
                      
                        <Tooltip title={`Sale: ${formatSaleValue(sale.data.sale[idx])}`} arrow>
                          <TableCell style={{textAlign :'center'}} className="sale-data-text">{formatSaleValue(sale.data.sale[idx])}</TableCell>
                        </Tooltip>
                        <Tooltip title={`Non-Saleable Return: ${sale.data.nonSaleableReturn[idx]}`} arrow>
                          <TableCell className="data-text">{sale.data.nonSaleableReturn[idx]}</TableCell>
                        </Tooltip>
                        <Tooltip title={`Saleable Return: ${sale.data.saleableReturn[idx]}`} arrow>
                          <TableCell className="data-text">{sale.data.saleableReturn[idx]}</TableCell>
                        </Tooltip>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </Box>
          </Card>
        ))}
      </Stack>
    </Box>
  );
});

export default StockistDataComp;




